<!--
@author: 赵静静
@time: 2021/11/1
@desc:  公用组件标准项目详情
-->
<template>
<div class="projectInfo">
  <el-form label-width="140px">
    <el-form-item label="项目内容" v-if="project.intro">
      <span class="text">{{ project.intro }}</span>
    </el-form-item>
    <el-form-item label="发布时间">
      <span class="text">{{ project.pubTime }}</span>
    </el-form-item>
    <el-form-item label="招工方">
      <span class="text">{{ project.pubName }}</span>
    </el-form-item>
    <el-form-item label="派活对象">
      <span class="text">{{ project.objects }}</span>
    </el-form-item>
    <el-form-item label="地点">
      <span class="text">{{ project.city }}</span>
    </el-form-item>
    <el-form-item label="报名时间">
      <span class="text">{{ project.signTime }}</span>
    </el-form-item>
    <el-form-item label="投标截止时间">
      <span class="text">{{ project.tenderEndTime }}</span>
    </el-form-item>
    <el-form-item label="开标时间">
      <span class="text">{{ project.bidOpenTime }}</span>
    </el-form-item>
    <el-form-item label="联系人">
      <span class="text">{{ project.personName }}</span>
    </el-form-item>
    <el-form-item label="联系人电话">
      <span class="text" style="margin-right: 10px">{{ project.mobile }}</span>
      <span style="color: #EE921A; font-size: 12px" v-show="!token">登录后可查看完整电话</span>
    </el-form-item>
    <el-form-item label="投标人范围" v-if="project.companyRange">
      <span v-if="project.companyRange == 1" class="text">所有人员</span>
      <span v-if="project.companyRange == 2" class="text" style="color: #0368C1" @click="toCompany">部分人员 >></span>
      <el-button type="text" v-if="project.companyRange == 2" class="selectCompanyRange" @click="CompanyRange">点击查看</el-button>
    </el-form-item>
    <el-form-item label="项目计划完工时间" v-if="project.finishTime">
      <span class="text">{{ project.finishTime }}</span>
    </el-form-item>
    <el-form-item label="撤销原因" v-if="project.reason">
      <span class="text">{{ project.reason }}</span>
    </el-form-item>
    <el-form-item label="附件" v-if="project.attachs !== undefined && project.attachs.length > 0">
      <el-link
        class="taskAffix"
        :underline="false"
        v-for="(item, index) in project.attachs"
        :key="index"
        :href="item.attachUrl"
      >
        <img src="../../assets/img/public/icon_pdf.png" class="taskAffixIcon" v-if="item.fileType === 'pdf'">
        <img src="../../assets/img/public/icon_excel.png" class="taskAffixIcon" v-else-if="item.fileType ==='xls' || item.fileType ==='xlsx'">
        <img src="../../assets/img/public/icon_ppt.png" class="taskAffixIcon" v-else-if="item.fileType ==='ppt' || item.fileType ==='pptx'">
        <img src="../../assets/img/public/icon_txt.png" class="taskAffixIcon" v-else-if="item.fileType === 'txt'">
        <img src="../../assets/img/public/icon_word.png" class="taskAffixIcon" v-else-if="item.fileType ==='doc' || item.fileType === 'docx'">
        <img src="../../assets/img/public/icon_img.png" class="taskAffixIcon" v-else-if="item.fileType === 'jpg' || item.fileType === 'png'" >
        <img src="../../assets/img/public/icon_default.png" class="taskAffixIcon" v-else>
        {{ item.attachName }}
      </el-link>
    </el-form-item>
    <el-form-item label="状态" v-if="typeText">
      <span class="type-text" :style="typeTextColor">{{ typeText }}</span>
    </el-form-item>
  </el-form>

  <el-dialog
    :visible.sync="CompanyRangeDilog"
    class="CompanyRangeDilog"
    width="30vw"
    center
  >
    <div class="product" v-for="(item, index) in list" :key="index">
      <div class="van-cell">{{ item.name }}</div>
    </div>
  </el-dialog>
</div>
</template>

<script>
import { getLimitCompanyList, changeGetLimitCompanyList } from '@api/project'
export default {
  name: 'projectInfo',
  props: ['project', 'typeText', 'typeColor', 'isMyRelease', 'oldInfo'],
  data () {
    return {
      typeTextColor: { color: '#F2B72D' },
      CompanyRangeDilog: false,
      list: [],
      token: ''
    }
  },
  created () {
    if (this.typeColor) {
      this.typeTextColor = { color: this.typeColor }
    }
    this.token = localStorage.getItem('token')
  },
  methods: {
    toCompany () {

    },
    editProject () {
      this.enterRouter('editBiaoZhunPage', { projectId: this.project.id })
    },
    CompanyRange () {
      this.CompanyRangeDilog = true
      if (!this.oldInfo) {
        this.getLimitCompanyList()
      } else {
        this.changeGetLimitCompanyList()
      }
    },
    // 获取队伍列表数据
    getLimitCompanyList () {
      getLimitCompanyList({
        projectId: this.project.id
      }).then(res => {
        if (res.data.code === 200) {
          this.list = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    changeGetLimitCompanyList () {
      changeGetLimitCompanyList({
        projectId: this.project.id
      }).then(res => {
        if (res.data.code === 200) {
          this.list = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
  .projectInfo{
    padding: 24px;
    background: #fff;
  }
.text{
  color: #333333;
  font-size: 16px;
}
  .type-text{
    font-size: 24px;
  }
  .CompanyRangeDilog{
    .product{
      font-size: 20px;
      color: #333;
      margin-bottom: 16px;
    }
  }
</style>
